<ng-container *ngIf="{
    row: columnData | async,
    aData: additionData | async
  } as $">
  <span *ngIf="$.row && $.aData && !isEmptyAndNull($.row[$.aData.primary]);else sec" [ngClass]="$.aData.color ? getColor($.row[$.aData.color]):''"> {{ $.row[$.aData.primary]}}</span>
  <ng-template #sec><span *ngIf="!isEmptyAndNull($.row[$.aData.secondary]);else empty" [ngClass]="$.aData.color ? getColor($.row[$.aData.color]):''">{{ $.row[$.aData.secondary]}}</span></ng-template>
  <ng-template #empty>-</ng-template>


</ng-container>
